import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { CardContent, Grid, Typography } from '@material-ui/core';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import PauseIcon from '@material-ui/icons/Pause';
import IconButton from '@material-ui/core/IconButton';
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon
} from '@material-ui/icons';
import Collapse from '@material-ui/core/Collapse';
import { fmtHSS, formatDateTime } from 'common/ui/utils';
import container from './EpisodeCard.container';
import clsx from 'clsx';
import PlayPauseButton from 'modules3/playbar/components/PlayPauseButton';

const useStyles = makeStyles((theme) => ({
  episode: {
    width: 655,
    margin: 'auto',
    marginTop: 10,
    padding: '16px 0px',
    border: '1px solid',
    borderColor: theme.palette.borderColor,
    borderRadius: 2,
    [theme.breakpoints.down('xs')]: {
      width: 330
    }
  },
  episodeTitle: {
    fontSize: 16,
    fontWeight: 'bold'
  },
  episodeSubtitle: {
    fontSize: 14,
    color: theme.palette.textColor2
  },
  episodeDescription: {
    fontSize: 14
  },
  iconButton: {},
  seeMore: {
    fontSize: 12,
    fontWeight: 'bold',
    color: theme.palette.textColor2
  },
  expand: {
    padding: 0,
    transform: 'rotate(0deg)',
    // marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    padding: 0,
    transform: 'rotate(180deg)'
  },
  playerIcon: {
    zIndex: 999,
    position: 'absolute',
    cursor: 'pointer',
    padding: 0,
    marginLeft: -17,
    marginTop: 25
    /*marginTop: -52,
        marginLeft: 290,
        [theme.breakpoints.down('xs')]: {
            marginLeft: 130,
        },*/
  },
  iconPlay: {
    width: 35,
    height: 35,
    fill: '#fff',
    background: '#ff0066',
    borderRadius: '50%'
  },
  icon: {
    display: 'inline-block',
    color: 'rgb(37, 37, 37)',
    fill: theme.palette.iconColor,
    userSelect: 'none',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    '&:hover': {
      color: theme.palette.iconHover,
      fill: theme.palette.iconHover
    }
  },
  detailsWrapper: {
    marginLeft: 35,
    paddingRight: 35,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 25,
      paddingRight: 15
    }
  },
  detailWrapper: {
    cursor: 'pointer'
  }
}));

const EpisodeCard = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  const {
    audioPlayer,
    playerPodCastState: { podcastid, episodeid, player, isLoading },
    onEpisodePlayerStart,
    onSetCurrentPodcastid,
    onSetPodcastQueue,
    onSetEpisodeClick
  } = props;

  const playerRef = audioPlayer.current;
  let duration = props.length;
  if (props.length && !props.length.toString().includes(':')) {
    duration = fmtHSS(props.length);
  }
  const [expanded, setExpanded] = React.useState(false);
  let audioStatus;
  if (player.state === -1) {
    audioStatus = 'loading';
  } else if (player.state === 0) {
    audioStatus = 'paused';
  } else if (player.state === 1) {
    audioStatus = 'playing';
  }

  const expandChangeHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setExpanded(!expanded);
  };

  const handlePlaying = () => {
    onEpisodePlayerStart(props.podcastid, props.episodeid);
    onSetCurrentPodcastid(props.podcastid);
    onSetPodcastQueue(props.podcastid, props.episodeid);
    onSetEpisodeClick();
  };

  return (
    <>
      <div className={classes.episode}>
        <CardContent className={classes.playerIcon} onClick={handlePlaying}>
          <Grid container justify="center">
            {/*{episodeid === props.episodeid && player.state > 0 ?
                            (
                                <PauseIcon className={classes.iconPlay}/>
                            ) : (
                                <PlayArrowIcon className={classes.iconPlay}/>
                            )
                        }*/}
            {episodeid === props.episodeid ? (
              <PlayPauseButton
                main={false}
                size={43}
                // expanded={expanded}
                player={playerRef}
                // toggleAudio={toggleAudio}
                status={audioStatus}
              />
            ) : (
              <PlayCircleFilledIcon
                style={{
                  fontSize: 43,
                  marginLeft: -2,
                  color: theme.palette.pink
                }}
              />
            )}
          </Grid>
        </CardContent>
        <div className={classes.detailsWrapper}>
          <div className={classes.detailWrapper} onClick={handlePlaying}>
            <Typography className={classes.episodeTitle}>
              <span
                className="line-clamp"
                dangerouslySetInnerHTML={{ __html: props.title }}
              />
            </Typography>
            <Typography className={classes.episodeSubtitle}>
              Duration: {duration}
            </Typography>
            <Typography className={classes.episodeSubtitle}>
              <span
                className="line-clamp"
                dangerouslySetInnerHTML={{
                  __html: formatDateTime(props.pub_date)
                }}
              />
            </Typography>
          </div>
          {expanded ? (
            <span className={classes.seeMore}>See Less</span>
          ) : (
            <span className={classes.seeMore}>See More</span>
          )}
          <IconButton
            className={clsx(classes.expand, {
              [classes.expandOpen]: expanded
            })}
            style={{ pointer: 'cursor' }}
            onClick={expandChangeHandler}
          >
            <ExpandMoreIcon className={classes.icon} />
          </IconButton>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Typography className={classes.episodeDescription}>
              <span
                className="line-clamp"
                dangerouslySetInnerHTML={{ __html: props.description }}
              />
            </Typography>
          </Collapse>
        </div>
      </div>
    </>
  );
};

export default container(EpisodeCard);
